/* eslint-disable import/prefer-default-export */
import { BillingAddress, Settings } from 'CoreApi.Settings_V12';
import qs from 'qs';
import {
  allPass,
  complement,
  gte,
  isEmpty,
  isNil,
  prop,
  curry,
  both,
  either,
  compose,
} from 'ramda';

const isNotNil = complement(isNil);
const isNotEmpty = complement(isEmpty);
const isValueFilled = both(isNotNil, isNotEmpty);
const len = (s: string) => s.length;

const isLengthGTE = curry(
  (n: number, v: unknown) =>
    typeof v === 'string' && isValueFilled(v) && gte(len(v), n)
);

const isStreetFilled = compose(
  isValueFilled,
  prop('address1') as (obj: Partial<BillingAddress>) => string
);
const isCityFilled = compose(
  isValueFilled,
  prop('city') as (obj: Partial<BillingAddress>) => string
);
const isCountryFilled = compose(
  isValueFilled,
  prop('country') as (obj: Partial<BillingAddress>) => string
);
const isZipcodeFilled = compose(
  isValueFilled,
  prop('zipcode') as (obj: Partial<BillingAddress>) => string
);
const isVatNumberFilled = compose(
  isValueFilled,
  prop('vat_number') as (obj: Partial<BillingAddress>) => string
);

const isTaxNumberFilled = compose(
  isValueFilled,
  prop('tax_number') as (obj: Partial<BillingAddress>) => string
);
const isCompanyFilled = compose(
  isLengthGTE(3),
  prop('company') as (obj: Partial<BillingAddress>) => string
);

export const isBillingAddressComplete: (v: BillingAddress) => boolean = allPass(
  [
    isCompanyFilled,
    isCountryFilled,
    isStreetFilled,
    isCityFilled,
    isZipcodeFilled,
  ]
);

export const isTaxInformationComplete: (v: Partial<Settings>) => boolean =
  either(isVatNumberFilled, isTaxNumberFilled);

export const extractCursorFromURL = (url: string) =>
  qs.parse(url.slice(url.lastIndexOf('?') + 1)).cursor as string | undefined;

export const downloadFile = (
  fileUrl: string,
  fileName: string,
  newTab: boolean = false
) => {
  const a = document.createElement('a');
  a.href = fileUrl;
  a.download = fileName;
  if (newTab) a.target = '_blank';
  a.click();
};
